import { SpeedDial } from "primereact/speeddial";
import styled from "styled-components";
import breakpoints from "../../utils/breakpoints";
import { Link } from "gatsby-plugin-react-i18next";

export const MainNav = styled.nav`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 1.5rem;
  padding-left: 1.5rem;
  transition: 0.2s all ease-in-out;
  z-index: 3;
  position: sticky;
  top: 0;
  background-color: var(--background);
  ${({ shadowed }) =>
    shadowed && "box-shadow: 0 4px 7px -5px rgba(0, 0, 0, 0.7);"}
`;

export const LogoContainer = styled.div`
  & a {
    text-decoration: none;
    display: flex;
    align-items: center;
  }
  & h1 {
    padding-left: 1rem;
    font-family: "Lobster Two", cursive;
    color: #333;
    font-size: 2rem;
  }
`;

// font-family: 'Bitter', serif;
export const PageList = styled.nav`
  list-style-type: none;
  display: flex;
  margin: 0;
  align-items: center;

  ${({ mobile }) =>
    !mobile &&
    breakpoints.mdMax`
    flex-direction: row-reverse;
  `}

  ${({ mobile }) =>
    mobile &&
    `
    flex-direction: column;

    & > li:not(:last-child) {
      margin-bottom: 1rem;
    }
  `}

  & > li {
    font-weight: 700;
    padding-right: 1.5rem;
  }
`;

export const LangSelectionContainer = styled.div`
  position: absolute;
  font-size: 0.7rem;
`;

export const NonLinkButton = styled.span`
  cursor: pointer;
`;

export const NavMenuContainer = styled.div`
  display: inline;

  & > *:nth-child(1) {
    display: flex;
  }
  & > *:nth-child(2) {
    display: none;
  }

  ${breakpoints.mdMax`
    & > *:nth-child(1) {
      display: none;
    }
    & > *:nth-child(2) {
      display: flex;
    }
  `}
`;

export const LanguageSpeedDial = styled(SpeedDial)`
  position: relative !important;
  top: 0;
  margin-left: -10px;

  & ul {
    position: absolute;
    top: 2.5rem;
    transition: 0.3s ease-in-out background;
  }

  ${breakpoints.mdMax`
    margin-left: 0;
    margin-right: 10px;
  `}
`;

export const LanguageButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;

  & > span {
    margin-right: 0.5rem;
  }
`;

// BETTER LANGUAGE SELECTOR
export const LanguageSelectorContainer = styled.nav`
  position: relative;

  ${({ mobile }) => mobile && `margin-right: 2rem;`}
`;

export const CurrentLanguage = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;

  & span {
    margin: 0 0.2rem;
  }
`;

export const LanguageSelectorDrawer = styled.ul`
  transition: 0.2s ease-in-out transform;
  box-shadow: 0 4px 7px -5px rgba(0, 0, 0, 0.7);
  transform-origin: top center;
  transform: scaleY(${({ shouldShow }) => (shouldShow ? 1 : 0)});
  right: 0;
  position: absolute;
  background: var(--background);
  padding: 0;
  list-style: none;
  border-radius: 0 0 1rem 1rem;
  overflow: hidden;
`;

export const LanguageSelectorItem = styled(Link)`
  margin-top: 0.3rem;
  padding: 0 0.6rem 0.6rem 0.6rem;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const FlagIcon = styled.img`
  width: auto;
  height: 1rem;
  margin-right: 0.5rem;
`;
